import { ISlotGameSettings, SlotGameSettings } from '@cgs/machines';

type ICorsicaGameSettings = ISlotGameSettings & {
  symbols: ISlotGameSettings['symbols'] & {
    freeSpinsIcons: Record<string, string>;
  };
};

export const corsicaGameSettings: ICorsicaGameSettings = {
  paytable: {
    resourcePath: 'paytable/html',
    sections: [[2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]],
  },
  symbols: {
    simpleIcons: {
      '1': 'bonus_01.png',
      '2': 'napoleon.png',
      '3': 'bandana_rebel.png',
      '4': 'masked_rebel.png',
      '5': 'corsican_boar.png',
      '6': 'dynamite.png',
      '7': 'ellipse_band.png',
      '8': 'band_logo.png',
      '9': 'bandana.png',
      '10': 'tire.png',
      '11': 'sign_03.png',
      '12': 'coctail.png',
      '13': 'dagger.png',
    },
    specialIcons: {
      SCATTER: 'bonus_01.png',
    },
    freeSpinsIcons: {
      '14': 'swat.png',
      '15': 'bandana_rebel_fs.png',
      '16': 'masked_rebel_fs.png',
    },
    extraIcons: {},
    maxIconId: 20,
  },
  paylines: {
    game: [
      [0, 0, 0, 0, 0],
      [1, 1, 1, 1, 1],
      [2, 2, 2, 2, 2],
      [3, 3, 3, 3, 3],
      [1, 1, 2, 1, 1],
      [2, 2, 1, 2, 2],
      [0, 0, 1, 0, 0],
      [3, 3, 2, 3, 3],
      [3, 2, 1, 2, 3],
      [0, 1, 2, 1, 0],
      [3, 2, 3, 2, 3],
      [0, 1, 0, 1, 0],
      [1, 2, 1, 2, 1],
      [2, 1, 2, 1, 2],
      [1, 2, 2, 2, 1],
      [2, 1, 1, 1, 2],
      [0, 0, 1, 2, 2],
      [1, 1, 2, 3, 3],
      [3, 3, 2, 1, 1],
      [2, 2, 1, 0, 0],
      [1, 0, 1, 2, 1],
      [1, 2, 1, 0, 1],
      [2, 3, 2, 1, 2],
      [2, 1, 2, 3, 2],
      [0, 1, 1, 1, 0],
      [3, 2, 2, 2, 3],
      [0, 1, 2, 3, 2],
      [2, 3, 2, 1, 0],
      [3, 2, 1, 0, 1],
      [1, 0, 1, 2, 3],
      [0, 2, 2, 2, 0],
      [3, 1, 1, 1, 3],
      [2, 0, 0, 0, 2],
      [1, 3, 3, 3, 1],
      [0, 0, 3, 0, 0],
      [3, 3, 0, 3, 3],
      [2, 3, 0, 3, 2],
      [1, 0, 3, 0, 1],
      [0, 3, 0, 3, 0],
      [3, 0, 3, 0, 3],
    ],
    dev: [
      [0, 1, 2, 3, 4],
      [5, 6, 7, 8, 9],
      [10, 11, 12, 13, 14],
      [15, 16, 17, 18, 19],
      [5, 6, 12, 8, 9],
      [10, 11, 7, 13, 14],
      [0, 1, 7, 3, 4],
      [15, 16, 12, 18, 19],
      [15, 11, 7, 13, 19],
      [0, 6, 12, 8, 4],
      [15, 11, 17, 13, 19],
      [0, 6, 2, 8, 4],
      [5, 11, 7, 13, 9],
      [10, 6, 12, 8, 14],
      [5, 11, 12, 13, 9],
      [10, 6, 7, 8, 14],
      [0, 1, 7, 13, 14],
      [5, 6, 12, 18, 19],
      [15, 16, 12, 8, 9],
      [10, 11, 7, 3, 4],
      [5, 1, 7, 13, 9],
      [5, 11, 7, 3, 9],
      [10, 16, 12, 8, 14],
      [10, 6, 12, 18, 14],
      [0, 6, 7, 8, 4],
      [15, 11, 12, 13, 19],
      [0, 6, 12, 18, 14],
      [10, 16, 12, 8, 4],
      [15, 11, 7, 3, 9],
      [5, 1, 7, 13, 19],
      [0, 11, 12, 13, 4],
      [15, 6, 7, 8, 19],
      [10, 1, 2, 3, 14],
      [5, 16, 17, 18, 9],
      [0, 1, 17, 3, 4],
      [15, 16, 2, 18, 19],
      [10, 16, 2, 18, 14],
      [5, 1, 17, 3, 9],
      [0, 16, 2, 18, 4],
      [15, 1, 17, 3, 19],
    ],
  },
  cheat: {
    url: 'configs/cheat.json',
  },
  config: {
    url: 'configs/game-config.json',
    bonusPath: 'configs/bonus',
  },
};

export class CorsicaGameSettings extends SlotGameSettings {
  public getScatterId(): number {
    return 1;
  }

  public getNonValueFreeSpinIcon(): number {
    return 15;
  }

  public getBonusId(): number {
    return 16;
  }

  public getSpecialFreeSpinIcon(): number[] {
    return [16, 17, 18, 19, 20];
  }
}
